import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { AnvandareOrganisation } from '../../services/auth.model';
import { AnvandareService } from 'src/app/pages/anvandare/anvandare.service';
import { AnvandareDTO } from 'src/app/pages/anvandare/anvandare.models';
import { ApiService } from 'src/app/api/api.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-valj-organisation',
  standalone: false,
  templateUrl: './valj-organisation.component.html',
})
export class ValjOrganisationComponent implements OnInit {
  private sessionService = inject(SessionService);
  private anvandareService = inject(AnvandareService);
  private apiService = inject(ApiService);
  private router = inject(Router);
  private destroy = inject(DestroyRef);
  protected anvandareOrganisationer$: Observable<AnvandareOrganisation[]> =
    this.anvandareService.getLoggedInUserOrganisations();

  ngOnInit(): void {
    this.sessionService.loggedInSingleOrg$.subscribe((loggedIn) => {
      if (loggedIn) {
        this.anvandareService.anvandareOrganisationChange$.next(
          !this.anvandareService.anvandareOrganisationChange$.getValue(),
        );
        this.router.navigate(['startsida']);
      }
    });
  }

  loginWithSpecifiedOrganisation(event: any) {
    const chosenOrgId = event.value.organisationId;

    //this.anvandareService
      // .loginAnvandareOrganisation(chosenOrgId)
      // .pipe(takeUntilDestroyed(this.destroy))
      // .subscribe(() => {
        this.apiService.reAuthenticate(chosenOrgId);
     // });
  }
}
